module.exports = __webpack_public_path__ + "img/public/AdminIcons/adminImportIcon.svg?cb120eea";